<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
<style rel="stylesheet/scss"  lang="scss">
.el-table-border th.gutter:last-of-type {
  display: block !important;
  width: 17px !important;
}
body .el-table th.gutter {
  display: table-cell !important;
}

body .el-table colgroup.gutter {
  display: table-cell !important;
}

.el-message-box {
  width: auto !important;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 2px;
  background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 2px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #eee;
}
.el-menu .el-menu--inline {
  background: #1f2d3d !important;
  li {
    border-top: 1px solid rgb(48, 65, 86);
  }
}

span,
div,
p,
label,
div {
  font-size: 12px;
}
.el-radio-group,
.el-checkbox-group {
  font-size: 0 !important ;
}
.el-checkbox-group {
  .el-button {
    vertical-align: unset;
  }
}
.el-select-dropdown {
  max-height: 300px !important;
}
.el-select-dropdown .el-scrollbar{
  max-height: 300px ;
  overflow-y: scroll ;
}
.el-submenu__title {
  font-size: 18px !important;
}
.el-menu-item {
  font-size: 18px !important;
}
.media-select {
  display: inline-block;
}

.el-table .caret-wrapper {
  position: absolute !important;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.viewer_box{
  z-index: 10000;
  position: fixed;
  width: 100%;
  height: 66px;
  line-height: 20px;
  text-align: right;
  top: 35px;
  right:135px;
  .viewer_tips{
    color: red;
    font-size: 17px;
  }
}
.el-dialog__footer {
  border-top: 1px #d9d9d9 solid;
  padding: 20px 20px;
}

.el-table-filter {
  height: 150px;
  overflow-y: auto;
}
</style>
